import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ThankyouComponent } from './features/thankyou/thankyou.component';

const routes: Routes = [
   {
    path: '',
    loadChildren: () =>
      import('./features/home/home.module').then(m => m.HomeModule)
  },
  {
  path: 'contact',
  loadChildren: () =>
    import('./features/contact/contact.module').then(m => m.ContactModule)
  },
  {
  path: 'about',
  loadChildren: () =>
    import('./features/about/about.module').then(m => m.AboutModule)
  },
  {
    path: 'admissions',
    loadChildren: () =>
      import('./features/admissions/admissions.module').then(m => m.AdmissionsModule)
  },
  {
    path: 'events',
    loadChildren: () =>
      import('./features/events/events.module').then(m => m.EventsModule)
  },
  {
    path: 'blogs',
    loadChildren: () =>
      import('./features/blogs/blogs.module').then(m => m.BlogsModule)
  },
  {
    path: 'courses',
    loadChildren: () =>
      import('./features/courses/courses.module').then(m => m.CoursesModule)
  },
  {
    path: 'career-and-placements',
    loadChildren: () =>
      import('./features/placements/placements.module').then(m => m.PlacementsModule)
  },
  {
    path: 'campus-life',
    loadChildren: () =>
      import('./features/campus-life/campus-life.module').then(m => m.CampusLifeModule)
  },
  {
    path: 'research',
    loadChildren: () =>
      import('./features/research/research.module').then(m => m.ResearchModule)
  },
  {
    path: 'academics',
    loadChildren: () =>
      import('./features/academics/academics.module').then(m => m.AcademicsModule)
  },
  {
    path: 'students-activity-portal',
    loadChildren: () =>
      import('./features/students-activity-portal/students-activity-portal.module').then(m => m.StudentsActivityPortalModule)
  },
  {
    path: 'committees',
    loadChildren: () =>
      import('./features/committees/committees.module').then(m => m.CommitteesModule)
  },
  {
    path: 'nirf',
    loadChildren: () =>
      import('./features/nirf/nirf.module').then(m => m.NirfModule)
  },

  {
    path: 'courses',
    loadChildren: () =>
      import('./features/courses/courses.module').then(m => m.CoursesModule)
  },
  {
  path: 'thankyou',
  component: ThankyouComponent,
  data: {
    title: 'Thank You | GHRCEM Pune',
    robots: 'noindex, nofollow'
  }
},
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled',
     onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
